import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getTrendingChannelsWithUserdata } from '../../../api/channels';

import {
  checkAndSetLoading,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { mergeChannelsWithUserDatas } from '../../../utils/channels';
import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';

import { REQUEST } from '../../../constants/request';

export const fetchTrendingChannels = createAsyncThunk(
  `channels/fetchTrendingChannels`,
  async (_, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [trendingChannelsRes, trendingChannelsUserdataRes] =
        await getTrendingChannelsWithUserdata(_, {
          cancelToken: source.token,
        });

      return mergeChannelsWithUserDatas(
        trendingChannelsRes,
        trendingChannelsUserdataRes,
      );
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (_, { getState }) => {
      const { channels } = getState();

      return !(
        channels.channels.displayTrendingChannels.request.loading ===
        REQUEST.pending
      );
    },
  },
);

export const fetchTrendingChannelsExtraReducers = {
  [fetchTrendingChannels.pending]: (state, action) => {
    checkAndSetLoading(state.channels.displayTrendingChannels.request, action);
  },
  [fetchTrendingChannels.fulfilled]: (state, action) => {
    onMatchedRequest(
      state.channels.displayTrendingChannels.request,
      action,
      () => {
        const trendingById = action.payload.reduce((accChannel, curChannel) => {
          const channelCIDKey = generateChannelCIDKey(curChannel);
          return {
            ...accChannel,
            [channelCIDKey]: curChannel,
          };
        }, {});

        state.channels.displayTrendingChannels.layout =
          Object.keys(trendingById);

        const byId = {
          ...state.channels.channel.byId,
          ...trendingById,
        };

        state.channels.channel.byId = byId;
        state.channels.channel.allIds = Object.keys(byId);
      },
    );
  },
  [fetchTrendingChannels.rejected]: (state, action) => {
    handleRequestRejection(
      state.channels.displayTrendingChannels.request,
      action,
    );
  },
};
